import { MoneyPatternType } from '@dreryk/react-common';
import {
   InteractiveTable,
   InteractiveTableCellProps,
   StyledFlex,
   useInteractiveTableContext,
} from '@dreryk/react-components';

import { invoiceCreateModalTranslationKeys } from '../../../translations';

import { InvoiceItemsTableBean } from './InvoiceItemsTable.types';
import { medicalServiceRowVisitor, NEW_ROW_EMPTY_VALUE_PLACEHOLDER } from './InvoiceItemsTable.utils';

const MAX_VALUE = 999999.99;
const MIN_VALUE = 0.01;
const INPUT_LENGTH = 7;

type InvoiceItemsTableUnitPriceCellProps = InteractiveTableCellProps<number>;

export const InvoiceItemsTableUnitPriceCell = (props: InvoiceItemsTableUnitPriceCellProps): JSX.Element => {
   const { defaultValue, index, name, testId } = props;

   const { getCellValue } = useInteractiveTableContext<InvoiceItemsTableBean>();
   const { nameEditable, rowAddedManually, unitDefaultPrice } = getCellValue('invoiceParameters', index);
   const unitPrice = getCellValue('unitPrice', index);

   return medicalServiceRowVisitor({
      nameEditable: nameEditable,
      rowAddedManually: rowAddedManually,
   })({
      visitFetchedRow: () => (
         <InteractiveTable.MoneyInputCell
            defaultValue={defaultValue}
            index={index}
            max={MAX_VALUE}
            maxSize={INPUT_LENGTH}
            min={MIN_VALUE}
            minSize={INPUT_LENGTH}
            name={name}
            pattern={MoneyPatternType.POSITIVE_WITH_PRECISION}
            testId={testId}
            validationRules={{
               required: true,
            }}
            warning={
               unitDefaultPrice === unitPrice ? undefined : invoiceCreateModalTranslationKeys.table.unitPriceTooltip
            }
         />
      ),
      visitManuallyAddedRow: () => (
         <InteractiveTable.CustomCell defaultValue={defaultValue} index={index} name={name} testId={testId}>
            {() => <StyledFlex justifyContent={'flex-end'}>{NEW_ROW_EMPTY_VALUE_PLACEHOLDER}</StyledFlex>}
         </InteractiveTable.CustomCell>
      ),
      visitManuallyAddedRowWithName: () => (
         <InteractiveTable.MoneyInputCell
            defaultValue={unitPrice}
            index={index}
            max={MAX_VALUE}
            maxSize={INPUT_LENGTH}
            min={MIN_VALUE}
            minSize={INPUT_LENGTH}
            name={name}
            pattern={MoneyPatternType.POSITIVE_WITH_PRECISION}
            testId={testId}
            validationRules={{
               required: true,
            }}
         />
      ),
   });
};
